/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskDistributionAllocations
 */
export interface ExecRiskDistributionAllocations {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    cy_distributable_as_adjusted_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    underdistributions_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_cyov_yr_5_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_cyov_yr_4_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_cyov_yr_3_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_cyov_yr_2_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_cyov_yr_1_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    total_excess_distribution_cyov_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    cyov_applied_underdistri_py_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    cyov_applied_underdistr_cpy_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    carryover_py_not_applied_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_cyov_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    cy_total_annual_distributions_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    cy_distrib_app_underdistri_py_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    cy_distri_app_distributable_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distribution_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    remaining_underdistri_py_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    remaining_underdistri_cy_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_distri_cyov_to_next_yr_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_from_year_5_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_from_year_4_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_from_year_3_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_from_year_2_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskDistributionAllocations
     */
    excess_from_year_1_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskDistributionAllocations interface.
 */
export function instanceOfExecRiskDistributionAllocations(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskDistributionAllocationsFromJSON(json: any): ExecRiskDistributionAllocations {
    return ExecRiskDistributionAllocationsFromJSONTyped(json, false);
}

export function ExecRiskDistributionAllocationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskDistributionAllocations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cy_distributable_as_adjusted_amt': !exists(json, 'cy_distributable_as_adjusted_amt') ? undefined : json['cy_distributable_as_adjusted_amt'],
        'underdistributions_amt': !exists(json, 'underdistributions_amt') ? undefined : json['underdistributions_amt'],
        'excess_distribution_cyov_yr_5_amt': !exists(json, 'excess_distribution_cyov_yr_5_amt') ? undefined : json['excess_distribution_cyov_yr_5_amt'],
        'excess_distribution_cyov_yr_4_amt': !exists(json, 'excess_distribution_cyov_yr_4_amt') ? undefined : json['excess_distribution_cyov_yr_4_amt'],
        'excess_distribution_cyov_yr_3_amt': !exists(json, 'excess_distribution_cyov_yr_3_amt') ? undefined : json['excess_distribution_cyov_yr_3_amt'],
        'excess_distribution_cyov_yr_2_amt': !exists(json, 'excess_distribution_cyov_yr_2_amt') ? undefined : json['excess_distribution_cyov_yr_2_amt'],
        'excess_distribution_cyov_yr_1_amt': !exists(json, 'excess_distribution_cyov_yr_1_amt') ? undefined : json['excess_distribution_cyov_yr_1_amt'],
        'total_excess_distribution_cyov_amt': !exists(json, 'total_excess_distribution_cyov_amt') ? undefined : json['total_excess_distribution_cyov_amt'],
        'cyov_applied_underdistri_py_amt': !exists(json, 'cyov_applied_underdistri_py_amt') ? undefined : json['cyov_applied_underdistri_py_amt'],
        'cyov_applied_underdistr_cpy_amt': !exists(json, 'cyov_applied_underdistr_cpy_amt') ? undefined : json['cyov_applied_underdistr_cpy_amt'],
        'carryover_py_not_applied_amt': !exists(json, 'carryover_py_not_applied_amt') ? undefined : json['carryover_py_not_applied_amt'],
        'excess_distribution_cyov_amt': !exists(json, 'excess_distribution_cyov_amt') ? undefined : json['excess_distribution_cyov_amt'],
        'cy_total_annual_distributions_amt': !exists(json, 'cy_total_annual_distributions_amt') ? undefined : json['cy_total_annual_distributions_amt'],
        'cy_distrib_app_underdistri_py_amt': !exists(json, 'cy_distrib_app_underdistri_py_amt') ? undefined : json['cy_distrib_app_underdistri_py_amt'],
        'cy_distri_app_distributable_amt': !exists(json, 'cy_distri_app_distributable_amt') ? undefined : json['cy_distri_app_distributable_amt'],
        'excess_distribution_amt': !exists(json, 'excess_distribution_amt') ? undefined : json['excess_distribution_amt'],
        'remaining_underdistri_py_amt': !exists(json, 'remaining_underdistri_py_amt') ? undefined : json['remaining_underdistri_py_amt'],
        'remaining_underdistri_cy_amt': !exists(json, 'remaining_underdistri_cy_amt') ? undefined : json['remaining_underdistri_cy_amt'],
        'excess_distri_cyov_to_next_yr_amt': !exists(json, 'excess_distri_cyov_to_next_yr_amt') ? undefined : json['excess_distri_cyov_to_next_yr_amt'],
        'excess_from_year_5_amt': !exists(json, 'excess_from_year_5_amt') ? undefined : json['excess_from_year_5_amt'],
        'excess_from_year_4_amt': !exists(json, 'excess_from_year_4_amt') ? undefined : json['excess_from_year_4_amt'],
        'excess_from_year_3_amt': !exists(json, 'excess_from_year_3_amt') ? undefined : json['excess_from_year_3_amt'],
        'excess_from_year_2_amt': !exists(json, 'excess_from_year_2_amt') ? undefined : json['excess_from_year_2_amt'],
        'excess_from_year_1_amt': !exists(json, 'excess_from_year_1_amt') ? undefined : json['excess_from_year_1_amt'],
    };
}

export function ExecRiskDistributionAllocationsToJSON(value?: ExecRiskDistributionAllocations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cy_distributable_as_adjusted_amt': value.cy_distributable_as_adjusted_amt,
        'underdistributions_amt': value.underdistributions_amt,
        'excess_distribution_cyov_yr_5_amt': value.excess_distribution_cyov_yr_5_amt,
        'excess_distribution_cyov_yr_4_amt': value.excess_distribution_cyov_yr_4_amt,
        'excess_distribution_cyov_yr_3_amt': value.excess_distribution_cyov_yr_3_amt,
        'excess_distribution_cyov_yr_2_amt': value.excess_distribution_cyov_yr_2_amt,
        'excess_distribution_cyov_yr_1_amt': value.excess_distribution_cyov_yr_1_amt,
        'total_excess_distribution_cyov_amt': value.total_excess_distribution_cyov_amt,
        'cyov_applied_underdistri_py_amt': value.cyov_applied_underdistri_py_amt,
        'cyov_applied_underdistr_cpy_amt': value.cyov_applied_underdistr_cpy_amt,
        'carryover_py_not_applied_amt': value.carryover_py_not_applied_amt,
        'excess_distribution_cyov_amt': value.excess_distribution_cyov_amt,
        'cy_total_annual_distributions_amt': value.cy_total_annual_distributions_amt,
        'cy_distrib_app_underdistri_py_amt': value.cy_distrib_app_underdistri_py_amt,
        'cy_distri_app_distributable_amt': value.cy_distri_app_distributable_amt,
        'excess_distribution_amt': value.excess_distribution_amt,
        'remaining_underdistri_py_amt': value.remaining_underdistri_py_amt,
        'remaining_underdistri_cy_amt': value.remaining_underdistri_cy_amt,
        'excess_distri_cyov_to_next_yr_amt': value.excess_distri_cyov_to_next_yr_amt,
        'excess_from_year_5_amt': value.excess_from_year_5_amt,
        'excess_from_year_4_amt': value.excess_from_year_4_amt,
        'excess_from_year_3_amt': value.excess_from_year_3_amt,
        'excess_from_year_2_amt': value.excess_from_year_2_amt,
        'excess_from_year_1_amt': value.excess_from_year_1_amt,
    };
}

